import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import 'url-search-params-polyfill';
import TagManager from 'react-gtm-module';

// Project imports

import LoadMask from '../../components/LoadMask';
import { login, forgotPassword } from '../../redux/auth';
import { getLoginUI } from '../../redux/selectors';
// Module imports

import Form from './components/Form';
import ForgotPasswordModal from './components/ForgotPasswordModal';
import RecoverPasswordModal from './components/RecoverPasswordModal';

// Component imports

import luftLogo from '../../assets/images/luft-digital-white@2x.png';
import './styles.css';
import SelectCompanyModal from './components/SelectCompanyModal';
import { USER_TYPES } from '../Admin/shared/static-options';

// Component

const Login = ({
  dispatch,
  history,
  location,
  loginUI,
  accessToken,
  userType,
}) => {
  const recoverPasswordToken = new URLSearchParams(location.search).get(
    'recover-password-token',
  );

  const [showForgotPasswordModal, setShowForgotPasswordModal] = useState(false);
  const [showCustomerServiceModal, setShowCustomerServiceModal] =
    useState(false);
  const [showRecoverPasswordModal, setShowRecoverPasswordModal] = useState(
    recoverPasswordToken !== null,
  );

  const _login = ({ email, password }) => {
    dispatch(login(email, password)).then(
      // -disable-next-line no-shadow
      ({ userType, firstAccess, userId }) => {
        TagManager.dataLayer({ dataLayer: { userId } });
        if (userType === USER_TYPES.CUSTOMER_SERVICE_USER && !firstAccess) {
          setShowCustomerServiceModal(true);
        } else {
          const to =
            location.state && location.state.from ? location.state.from : '/u';
          history.push(to);
        }
      },
      // reject
      () => {},
    );
  };

  const _redirect = () => {
    const to =
      location.state && location.state.from ? location.state.from : '/u';
    history.push(to);
  };

  const _forgotPassword = ({ email }) => {
    dispatch(forgotPassword(email));
  };

  const _toggleForgotPasswordModal = () => {
    setShowForgotPasswordModal(!showForgotPasswordModal);
  };

  const _toggleRecoverPasswordModal = () => {
    setShowRecoverPasswordModal(!showRecoverPasswordModal);
  };

  if (
    accessToken &&
    !showRecoverPasswordModal &&
    userType !== USER_TYPES.CUSTOMER_SERVICE_USER
  ) {
    return <Redirect to="/u" />;
  }

  return (
    <div className="Login">
      <img src={luftLogo} className="Login__logo" alt="" />
      <Form
        className="Login__form"
        ui={loginUI}
        onSubmit={_login}
        onForgotPassword={_toggleForgotPasswordModal}
      />
      {showForgotPasswordModal && (
        <ForgotPasswordModal
          onBackdropClick={_toggleForgotPasswordModal}
          onSubmit={_forgotPassword}
        />
      )}
      {showRecoverPasswordModal && (
        <RecoverPasswordModal
          recoverPasswordToken={recoverPasswordToken}
          onBackdropClick={_toggleRecoverPasswordModal}
        />
      )}
      {loginUI.isFetching && <LoadMask text="Autenticando..." />}

      {showCustomerServiceModal && (
        <SelectCompanyModal onCompanySelect={_redirect} removeCloseModal />
      )}
    </div>
  );
};

// Redux
const mapStateToProps = state => ({
  accessToken: state.auth.accessToken,
  userType: state.auth.userType,
  loginUI: getLoginUI(state),
});
export default connect(mapStateToProps)(Login);
